import Container from '@/views/container'
export default [
  {
    path: '/',
    component: () => import('@/views/index'),
    meta: {
      hideInMenu: true
    }
  },
	{
		path: '/home',
		component: Container,
		meta: {
			title: '首页',
			icon: 'el-icon-cloudy',
			index: '10'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/home')
			}
		]
	},
	{
		path: '/user',
		component: Container,
		meta: {
			title: '用户管理',
			icon: 'el-icon-user',
			index: '20'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/user')
			}
		]
	},
	{
		path: '/goods-cate',
		component: Container,
		meta: {
			title: '商品分类',
			icon: 'el-icon-notebook-2',
			index: '30'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/goods-cate')
			}
		]
	},
	{
		path: '/goods',
		component: Container,
		meta: {
			title: '商品管理',
			icon: 'el-icon-goods',
			index: '40'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/goods')
			}
		]
	},
	{
		path: '/order',
		component: Container,
		meta: {
			title: '订单管理',
			icon: 'el-icon-document',
			index: '50'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/order')
			}
		]
	}
]